var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from '@angular/core';
import { FormComponent } from "../../../../../model/FormComponent";
import { FormField, RecordParamType } from "../../../../../model/Form";
import { Session } from "../../../../../service/util/Session";
import { CurrentUserService } from "../../../../../service/currentUser/CurrentUserService";
import { FormRecordService } from "../../../../../service/FormRecordService";
import { FormService } from "../../../../../service/FormService";
import { ErrorHandlerService } from "../../../../../service/ErrorHandlerService";
import { FollowUpWidgetComponent } from 'views/shared/followUpWidget.component';
import { Router } from '@angular/router';
import { riskTypeMap, riskTypeOptions } from '../../../../../model/RiskType';
import { logger } from 'service/util/Logger';
import { EnumService } from 'service/EnumService';
import { FollowUpService } from 'service/FollowUpService';
var RiskAssessmentFormStage3Component = /** @class */ (function (_super) {
    __extends(RiskAssessmentFormStage3Component, _super);
    function RiskAssessmentFormStage3Component(session, currentUserService, formRecordService, formService, errorHandler, router, enumService, followUpService) {
        var _this = _super.call(this, router) || this;
        _this.session = session;
        _this.currentUserService = currentUserService;
        _this.formRecordService = formRecordService;
        _this.formService = formService;
        _this.errorHandler = errorHandler;
        _this.router = router;
        _this.enumService = enumService;
        _this.followUpService = followUpService;
        _this.currentFormStage = 3;
        _this.className = "RiskAssessmentFormStage3Component";
        _this.documents = [];
        _this.riskType = 'General Risk';
        _this.followUpFormTypeId = null;
        _this.riskTypeOptions = riskTypeOptions;
        // When true this form will assign to the department head for signoff instead
        _this.departmentUserGroupId = null;
        _this.isExistingRisk = false;
        _this.readOnly = false;
        _this.hideHeader = false;
        /*
            This should have been done properly using something that implements FormControl but its
            too late now
         */
        _this.form = {
            reassign: new FormField(false, {
                validation: FormField.ValidationMethods.None
            }),
            //Since this will be assigned to a select it must be a string data - Conversion where appropriate
            reassignToUserId: new FormField('', {
                validation: FormField.ValidationMethods.None
            }),
            followUps: new FormField('[]', {
                nullEquivilent: "[]",
                recordParamType: RecordParamType.JSON,
                validation: function (value) {
                    return _this.followUpWidgetRef ? _this.followUpWidgetRef.validate() : true;
                }
            }),
            summary: new FormField('', {
                validation: FormField.ValidationMethods.None
            }),
        };
        return _this;
    }
    RiskAssessmentFormStage3Component.prototype.registerFormFields = function () {
        var _this = this;
        var _a;
        (_a = this.formFields).push.apply(_a, Object.keys(this.form).map(function (k) { return _this.form[k]; }));
    };
    RiskAssessmentFormStage3Component.prototype.ngOnInit = function () {
        this.loadEnums();
        this.registerFormFields();
        this.repopulateFormFromData();
    };
    RiskAssessmentFormStage3Component.prototype.onSubmit = function (isDraft) {
        var _this = this;
        if (isDraft === void 0) { isDraft = false; }
        var signature = this.className + ".onSubmit:";
        this.session.lockInput(function () {
            return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                var assignedUserId, stage, userGroupId;
                var _this = this;
                return __generator(this, function (_a) {
                    assignedUserId = this.currentUserService.userData && isDraft ? this.currentUserService.userData.id : null;
                    stage = this.currentFormStage;
                    userGroupId = null;
                    if (!isDraft) {
                        if (this.form.reassign.value && Number(this.form.reassignToUserId.value)) {
                            // The user is intending to reassign this form to another user
                            stage = 1;
                            userGroupId = this.departmentUserGroupId;
                            assignedUserId = Number(this.form.reassignToUserId.value);
                            logger.silly(signature + ("Assigning form to User[" + assignedUserId + "] and Group[" + userGroupId + "]"));
                        }
                        else {
                            stage = 4;
                            userGroupId = this.departmentUserGroupId;
                            logger.silly(signature + ("Assigning form to User[" + assignedUserId + "] and Group[" + userGroupId + "]"));
                        }
                    }
                    this.formService.updateForm({
                        id: this.formData.id,
                        formLocationId: this.formData.formLocationId,
                        userGroupId: userGroupId,
                        notifyOnComplete: this.formData.notifyOnComplete,
                        stage: stage,
                        assignedUserId: assignedUserId
                    }).subscribe(function (data) {
                        var properties = _this.toRecordParams(_this.form);
                        _this.formRecordService.createRecord({
                            formId: _this.formData.id,
                            properties: properties,
                            stage: _this.currentFormStage,
                            documents: _this.documents.map(function (doc) { return ({ id: doc.id, isTicked: !!doc.isTicked }); }),
                            isComplete: !isDraft
                        })
                            .subscribe(function (data) {
                            var success = function () {
                                resolve(data);
                                _this.session.requestPrevPage.next({ defaultUrl: '/ram-dashboard', filter: 'ram-dashboard' });
                            };
                            //Done creating the form and appending its properties
                            if (stage === 4) {
                                _this.formService.finalizeForm(_this.formData.id).subscribe(function () {
                                    var followUps = [];
                                    if (_this.form.followUps.value && _this.form.followUps.value.length) {
                                        followUps = JSON.parse(_this.form.followUps.value);
                                    }
                                    if (followUps.length === 0)
                                        return success();
                                    _this.followUpService.generateFollowUps(_this.formData.id, _this.formData.formLocationId, followUps, _this.followUpFormTypeId, success);
                                });
                            }
                            else {
                                success();
                            }
                        }, function (err) {
                            _this.errorHandler.handleHttpError(err);
                            reject("Error creating new record");
                        });
                    }, function (err) {
                        _this.errorHandler.handleHttpError(err);
                        reject("Error updating form");
                    });
                    return [2 /*return*/];
                });
            }); });
        });
    };
    /**
     * @description Fetches the original data from stage0
     */
    RiskAssessmentFormStage3Component.prototype.handleInitialData = function () {
        var lastStage0Submission = this.getMostRecentSubmission(this.formData, false, 0);
        var firstAssessment = this.getOldestSubmission(this.formData, false, 1, undefined);
        var lastAssessment = this.getMostRecentSubmission(this.formData, false, 1, undefined);
        if (!lastStage0Submission) {
            throw new Error("There should always be a stage 0 submission");
        }
        if (!firstAssessment) {
            throw new Error("There should always be a first 1 submission");
        }
        if (!lastAssessment) {
            throw new Error("There should always be a last 1 submission");
        }
        if (lastStage0Submission) {
            var propsOfInterest = {
                riskType: new FormField('1', {
                    recordParamType: RecordParamType.Number
                }),
                isExistingRisk: new FormField(false, {
                    recordParamType: RecordParamType.Boolean
                }),
                existingRisk: new FormField(null, {
                    validation: FormField.ValidationMethods.None
                })
            };
            this.updateFromRecordParams(propsOfInterest, lastStage0Submission);
            this.riskType = riskTypeMap[(propsOfInterest.riskType.value || '1').toString()];
            this.isExistingRisk = !!(propsOfInterest.isExistingRisk.value && propsOfInterest.existingRisk.value);
        }
        else {
            throw new Error("There should always be a stage 0 submission");
        }
    };
    RiskAssessmentFormStage3Component.prototype.repopulateFormFromData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var sequenceSubmission, lastStage0Submission, lastSubmission;
            return __generator(this, function (_a) {
                this.handleInitialData();
                if (this.sequence) {
                    sequenceSubmission = this.getMostRecentSubmission(this.formData, false, this.currentFormStage, this.sequence);
                    return [2 /*return*/, this.reloadExistingData(sequenceSubmission)];
                }
                lastStage0Submission = this.getMostRecentSubmission(this.formData, false, 0);
                if (!lastStage0Submission) {
                    throw new Error("There should always be a stage 0 submission");
                }
                this.departmentUserGroupId = this.getIntData(lastStage0Submission, 'initialAssessorDepartmentId');
                lastSubmission = this.getMostRecentSubmission(this.formData, true, this.currentFormStage);
                if (lastSubmission && !lastSubmission.isComplete) {
                    // We have draft Data
                    return [2 /*return*/, this.reloadExistingData(lastSubmission)];
                }
                return [2 /*return*/, this.loadFollowUpData()];
            });
        });
    };
    /**
     * @description Loads follow up data from the most recent submission of any type
     */
    RiskAssessmentFormStage3Component.prototype.loadFollowUpData = function () {
        var signature = this.className + ".loadFollowUpData: ";
        if (!this.form.followUps.valueIsNull) {
            logger.silly(signature + ("FollowUp Data Contains[" + this.form.followUps.value + "] and will not be loaded from previous submissions"));
            return;
        }
        var mostRecentSubmission = this.getMostRecentSubmission(this.formData, true);
        if (mostRecentSubmission) {
            var followUpData = this.getJsonData(mostRecentSubmission, 'followUps');
            this.form.followUps.value = followUpData;
        }
        else {
            logger.silly(signature + "Most recent submission not found");
        }
    };
    /**
     * @description Handles an incoming submission record by loading it into the form
     * @param {IFormRecordOutputModel|null} submission Allows null for convenience, does nothing if null is supplied
     * @returns {void}
     */
    RiskAssessmentFormStage3Component.prototype.reloadExistingData = function (submission) {
        if (!submission)
            return;
        this.formRecord = submission;
        this.updateFromRecordParams(this.form, this.formRecord);
        this.documents = this.initTickedDocuments(this.formRecord.documents, this.formRecord.tickedDocuments);
    };
    RiskAssessmentFormStage3Component.prototype.loadEnums = function () {
        var _this = this;
        this.session.lockInputRx(this.enumService.getEnumsByName('reportFormType'))
            .subscribe(function (data) {
            var followUpFormType = data.find(function (typeEnum) { return typeEnum.value.toLowerCase() === 'other'; });
            if (followUpFormType) {
                _this.followUpFormTypeId = followUpFormType.id;
            }
        });
    };
    return RiskAssessmentFormStage3Component;
}(FormComponent));
export { RiskAssessmentFormStage3Component };
